// ** React Imports
import { lazy } from 'react';

const CommissionTierRoutes = [
  {
    path: 'commission-tiers',
    component: lazy(() => import('views/commission-tiers')),
  },
  {
    path: 'commission-tier/add',
    component: lazy(() => import('views/commission-tiers/commission-tier-add')),
  },
  {
    path: 'commission-tier/:id',
    component: lazy(
      () => import('views/commission-tiers/commission-tier-edit'),
    ),
  },
  {
    path: 'commission-tier/show/:id',
    component: lazy(
      () => import('views/commission-tiers/commission-tier-show'),
    ),
  },
];

export default CommissionTierRoutes;
